import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "register_content"
};
const _hoisted_2 = {
  class: "register acea-row row-between-wrapper"
};
const _hoisted_3 = {
  class: "register_right"
};
const _hoisted_4 = {
  class: "register_box"
};
const _hoisted_5 = {
  class: "toum_box acea-row row-top row-middle"
};
const _hoisted_6 = {
  class: "toum_box acea-row row-top row-middle"
};
const _hoisted_7 = {
  class: "toum_box acea-row row-top row-middle"
};
const _hoisted_8 = {
  class: "toum_box acea-row row-top row-middle"
};
const _hoisted_9 = {
  class: "acea-row row-top"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_zrcheadernomenu = _resolveComponent("zrcheadernomenu");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_input = _resolveComponent("el-input");
  const _component_zrcfooter = _resolveComponent("zrcfooter");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_zrcheadernomenu, {
    xzmenu: $data.xzmenu
  }, null, 8, ["xzmenu"]), _createElementVNode("div", _hoisted_2, [_cache[12] || (_cache[12] = _createElementVNode("div", {
    class: "register_left"
  }, [_createElementVNode("div", {
    class: "register_title acea-row row-center-wrapper"
  }, "欢迎回来"), _createElementVNode("div", {
    class: "register_left_pic acea-row row-center-wrapper"
  }, [_createElementVNode("img", {
    src: "https://www.zcbz2023.com/webcss/login_left2.jpg"
  })])], -1)), _createElementVNode("div", _hoisted_3, [_cache[11] || (_cache[11] = _createElementVNode("div", {
    class: "register_tip"
  }, "输入账号和密码进行登录", -1)), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_el_col, {
    span: 5,
    class: "acea-row row-top"
  }, {
    default: _withCtx(() => _cache[6] || (_cache[6] = [_createElementVNode("text", {
      class: "hongse"
    }, "*", -1), _createTextVNode("手机号码 ")])),
    _: 1
  }), _createVNode(_component_el_col, {
    span: 16
  }, {
    default: _withCtx(() => [_createVNode(_component_el_input, {
      type: "text",
      modelValue: $data.dltel,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.dltel = $event),
      placeholder: "手机号码",
      clearable: ""
    }, null, 8, ["modelValue"])]),
    _: 1
  })]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_col, {
    span: 5,
    class: "acea-row row-top"
  }, {
    default: _withCtx(() => _cache[7] || (_cache[7] = [_createElementVNode("text", {
      class: "hongse"
    }, "*", -1), _createTextVNode("登录密码 ")])),
    _: 1
  }), _createVNode(_component_el_col, {
    span: 16
  }, {
    default: _withCtx(() => [_createVNode(_component_el_input, {
      type: "text",
      modelValue: $data.dlmima,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.dlmima = $event),
      placeholder: "登录密码",
      clearable: ""
    }, null, 8, ["modelValue"])]),
    _: 1
  })]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_col, {
    span: 5,
    class: "acea-row row-top"
  }), _createVNode(_component_el_col, {
    span: 16
  }, {
    default: _withCtx(() => [_createElementVNode("div", {
      class: "baidi_box_btn",
      onClick: _cache[2] || (_cache[2] = (...args) => $options.lijizhuce && $options.lijizhuce(...args))
    }, "点击登录")]),
    _: 1
  })]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_el_col, {
    span: 5,
    class: "acea-row row-top"
  }), _createVNode(_component_el_col, {
    span: 16,
    class: "acea-row acea-row row-between-wrapper"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_cache[8] || (_cache[8] = _createTextVNode(" 阅读并同意 ")), _createElementVNode("span", {
      onClick: _cache[3] || (_cache[3] = $event => $options.goxinwen(19, 4))
    }, "《服务协议》"), _cache[9] || (_cache[9] = _createTextVNode(" 和 ")), _createElementVNode("span", {
      onClick: _cache[4] || (_cache[4] = $event => $options.goxinwen(20, 4))
    }, "《隐私政策》")]), _createElementVNode("div", {
      class: "acea-row row-top",
      onClick: _cache[5] || (_cache[5] = $event => $options.menugo('/register'))
    }, _cache[10] || (_cache[10] = [_createElementVNode("div", null, "还没有账号？", -1), _createElementVNode("div", {
      class: "denglucolor"
    }, "立即注册", -1)]))]),
    _: 1
  })])])])]), _createVNode(_component_zrcfooter)]);
}